(() => {
  const sdkPromises = new Map();

  const loadPayPal = (clientId, currency) => {
    const key = `${clientId}:${currency}`;
    const namespace = `ThinkcarPayPal${currency}`;
    if (window[namespace]?.Messages) return Promise.resolve(window[namespace]);
    if (sdkPromises.has(key)) return sdkPromises.get(key);

    const promise = new Promise((resolve, reject) => {
      const url = new URL('https://www.paypal.com/sdk/js');
      url.searchParams.set('client-id', clientId);
      url.searchParams.set('components', 'messages');
      url.searchParams.set('currency', currency);

      const existing = document.querySelector(`script[data-thinkcar-paypal-sdk="${currency}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(window[namespace]), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = url.toString();
      script.async = true;
      script.dataset.thinkcarPaypalSdk = currency;
      script.dataset.namespace = namespace;
      script.addEventListener('load', () => resolve(window[namespace]), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    sdkPromises.set(key, promise);
    return promise;
  };

  class ThinkcarPayPalMessaging extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-paypal-message]');
      this.amount = Number(this.dataset.amount);
      this.renderMessage();

      if (window.theme?.pubsub && window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
        this.unsubscribe = window.theme.pubsub.subscribe(
          window.theme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (String(event.data.sectionId) !== this.dataset.sectionId) return;
            this.updateAmount(event.data.variant?.price);
          }
        );
      }

      this.variantHandler = (event) => this.updateAmount(event.detail?.variant?.price);
      this.closest('product-info')?.addEventListener('variant:change', this.variantHandler);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.closest('product-info')?.removeEventListener('variant:change', this.variantHandler);
    }

    updateAmount(priceInCents) {
      if (!Number.isFinite(Number(priceInCents))) return;
      this.amount = Number(priceInCents) / 100;
      this.renderMessage();
    }

    async renderMessage() {
      if (!this.target || !Number.isFinite(this.amount) || this.amount <= 0) return;

      try {
        const paypal = await loadPayPal(this.dataset.clientId, this.dataset.currency);
        if (!this.isConnected || !paypal?.Messages) return;
        this.target.replaceChildren();
        await paypal.Messages({
          amount: this.amount.toFixed(2),
          placement: 'product',
          buyerCountry: this.dataset.buyerCountry
        }).render(this.target);
      } catch (error) {
        console.warn('THINKCAR PayPal messaging could not load.', error);
      }
    }
  }

  if (!customElements.get('thinkcar-paypal-messaging')) {
    customElements.define('thinkcar-paypal-messaging', ThinkcarPayPalMessaging);
  }
})();
